import Question, { QuestionsContainer, QuestionWrapper } from 'components/reports/Question'
import OutputDetails, { OutputSubstanceDetails } from 'components/reports/OutputDetails'
import ReferrableQuestionWrapper from 'components/reports/ReferrableQuestionWrapper'
import { formatDateMonthYear } from 'hooks/useDateUtils'

export default function EatingDisorderDetails({ data }) {

    var questions = data.conditionSpecific.questions

    return (
        <>
            <h3>Eating Disorder Questions</h3>

            <QuestionsContainer>

                <QuestionWrapper number='1'>
                    <Question>Please provide details of the diagnosis and date of first presentation:</Question>
                    <ReferrableQuestionWrapper isReferred={questions.diagnosis.referToAttachments}>
                        <p>{questions.diagnosis.subQuestions.details}</p>

                        <Question>Date of first presentation:</Question>
                        <p>{formatDateMonthYear(questions.diagnosis.subQuestions.dateFirstPresented)}</p>
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='2'>
                    <Question>Please provide details of patient treatment:</Question>
                    <ReferrableQuestionWrapper isReferred={questions.treatmentProvided.referToAttachments}>
                        <p>{questions.treatmentProvided.value}</p>

                        <Question>Did the patient require any hospital stay(s) for treatment?</Question>
                        <p>{questions.treatmentProvided.subQuestions.anyInpatientAdmissions}</p>

                        {questions.treatmentProvided.subQuestions.anyInpatientAdmissions === 'Yes' && (
                            <>
                                <Question>If yes, please provide date(s) of hospital stay(s):</Question>
                                <OutputDetails
                                    details={questions.treatmentProvided.subQuestions.admissionDetails}
                                />
                            </>
                        )}
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='3'>
                    <Question>Please provide the date of the last episode, current height and weight:</Question>
                    <ReferrableQuestionWrapper isReferred={questions.otherDetails.referToAttachments}>
                        <br />
                        <QuestionsContainer>
                            <QuestionWrapper number='a'>
                                <Question>Date of last episode:</Question>
                                <p>{formatDateMonthYear(questions.otherDetails.subQuestions.dateOfLastEpisode)}</p>
                            </QuestionWrapper>
                        </QuestionsContainer>

                        <QuestionsContainer>
                            <QuestionWrapper number='b'>
                                <Question>Current Height:</Question>
                                <p>{questions.otherDetails.subQuestions.currentHeight}</p>
                            </QuestionWrapper>
                        </QuestionsContainer>

                        <QuestionsContainer>
                            <QuestionWrapper number='c'>
                                <Question>Current Weight:</Question>
                                <p>{questions.otherDetails.subQuestions.currentWeight}</p>
                            </QuestionWrapper>
                        </QuestionsContainer>
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='4'>
                    <Question>Has your patient always been compliant with recommended treatment and follow-ups?</Question>
                    <ReferrableQuestionWrapper isReferred={questions.compliantWithTreatment.referToAttachments}>
                        <p>{questions.compliantWithTreatment.value}</p>

                        <Question
                            show={questions.compliantWithTreatment.value === 'No'}
                            answer={questions.compliantWithTreatment.details}
                        >
                            If no, please provide full details:
                        </Question>
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='5'>
                    <Question>Is there any history of suicidal ideation, deliberate self-harm or suicide attempt?</Question>
                    <ReferrableQuestionWrapper isReferred={questions.historyOfSelfHarm.referToAttachments}>
                        <p>{questions.historyOfSelfHarm.value}</p>
                        {questions.historyOfSelfHarm.value === 'Yes' && (
                            <>
                                <Question>If yes, please provide details and dates:</Question>
                                <OutputDetails
                                    details={questions.historyOfSelfHarm.details}
                                />
                            </>
                        )}
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='6'>
                    <Question>Is there any history of misuse of drugs and/or alcohol?</Question>
                    <ReferrableQuestionWrapper isReferred={questions.historyOfSubstanceMisuse.referToAttachments}>
                        <p>{questions.historyOfSubstanceMisuse.value}</p>
                        {questions.historyOfSubstanceMisuse.value === 'Yes' && (
                            <>
                                <Question>If yes, please provide details of dates, substances used and levels of consumption:</Question>
                                <br />
                                <OutputSubstanceDetails
                                    details={questions.historyOfSubstanceMisuse.details}
                                />
                            </>
                        )}
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='7'>
                    <Question>Has your patient had any time off work?</Question>
                    <ReferrableQuestionWrapper isReferred={questions.anyTimeOffWorkCaused.referToAttachments}>
                        <p>{questions.anyTimeOffWorkCaused.value}</p>
                        {questions.anyTimeOffWorkCaused.value === 'Yes' && (
                            <>
                                <Question>If yes, please provide details of any time off work to include dates and duration:</Question>
                                <OutputDetails
                                    details={questions.anyTimeOffWorkCaused.details}
                                />
                            </>
                        )}
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='8'>
                    <Question>Are there any other factors or co-morbidities present which may influence the prognosis of this condition?</Question>
                    <ReferrableQuestionWrapper isReferred={questions.anyOtherFactors.referToAttachments}>
                        <p>{questions.anyOtherFactors.value}</p>
                        {questions.anyOtherFactors.value === 'Yes' && (
                            <>
                                <Question>If yes, please provide details:</Question>
                                <p>{questions.anyOtherFactors.details}</p>
                            </>
                        )}
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

            </QuestionsContainer>
        </>
    )
}